import React, { useState, useEffect } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Card, CardBody, Container, Row, Col } from "reactstrap"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import SButton from "components/Common/Button"
import Table from "./Table"
import Skeleton from "react-loading-skeleton"
import { getOrderSheetAPI } from "helpers/order_sheet"
import SelectBox from "components/Common/SelectBox"
import { CustomPagination as Pagination } from "components/Common/Pagination"

export default function OrderSheetCreation() {
  const [data, setData] = useState([])
  const [isFetching, setIsFetching] = useState(false)

  const [filter, setFilter] = useState({
    productName: "",
    categoryName: "",
    configurationStatus: "",
  })

  const [page, setPage] = useState(0)
  const [size, setSize] = useState(10)
  const [count, setCount] = useState(100)

  const [configStatus, setConfigStatus] = useState({ value: "", label: "" })

  const onFilter = e => {
    setFilter({ ...filter, [e.target.name]: e.target.value })
  }

  const onConfigChange = e => {
    setConfigStatus(e)
    setFilter({ ...filter, configurationStatus: e.value })
  }

  const params = {
    productName: filter.productName,
    categoryName: filter.categoryName,
    configurationStatus: filter.configurationStatus,
    page: page,
    size: size,
  }

  const fetchData = async (params) => {
    setIsFetching(true)
    
    try {
      let res = await getOrderSheetAPI(params)
      if (res.status === 200) {
        setData(res.data.content)
        setSize(res.data.size)
        setCount(res.data.totalPages)
        // setPage(res.data.number);
        setIsFetching(false)
      }
    } catch (error) {
      console.log("err: ", error.response)
    }
  }

  const onSearch = () => {
    const _params = Object.fromEntries(
      Object.entries({...filter, page, size}).filter(val => val[1] !== "")
    )
    fetchData(_params)
  }

  useEffect(() => {
    fetchData({page, size})
  }, [])

  useEffect(() => {
    const _params = Object.fromEntries(
      Object.entries({...filter, page, size}).filter(val => val[1] !== "")
    )
    fetchData(_params)
  }, [page])


  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={"オーダーシート作成"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col sm={3}>
                <TextInputWithLabel
                  label={"商品カテゴリ"}
                  placeholder={""}
                  value={filter.categoryName}
                  type="text"
                  name="categoryName"
                  onChange={onFilter}
                />
              </Col>
              <Col sm={3}>
                <TextInputWithLabel
                  label={"商品名"}
                  placeholder={""}
                  value={filter.productName}
                  type="text"
                  name="productName"
                  onChange={onFilter}
                />
              </Col>
              <Col sm={3}>
                <SelectBox
                  label={"設定ステータス"}
                  options={[
                    { label: " 済み", value: true },
                    { label: "未設定", value: false },
                  ]}
                  value={configStatus}
                  onChange={onConfigChange}
                />
              </Col>
              <Col md={3} className="d-flex align-content-end flex-wrap">
                <SButton onClick={onSearch} className="mx-2 button">
                  検索
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Col>
              {isFetching ? (
                <Skeleton count={5} />
              ) : (
                <>
                  <Table
                    page={page}
                    size={size}
                    count={count}
                    content={data}
                    setSize={size => {
                      let _filter = { ...params }
                      _filter.size = size

                      fetchData(_filter)
                      setSize(size)
                    }}
                    setPage={page => {
                      let _filter = { ...params }
                      _filter.page = page
                      fetchData(_filter)
                      setPage(page)
                    }}
                  />
                </>
              )}
            </Col>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
